// Mock data for Enrigo platform - will be replaced with backend APIs

export const mockProjects = [
  {
    id: '1',
    title: 'Premium Brand Identity',
    category: 'Print Design',
    image: 'https://images.unsplash.com/photo-1652805363265-b8fbf9bbdfac',
    description: 'Complete brand identity design including logo, business cards, and marketing materials',
    client: 'Tech Startup Inc',
    year: '2024',
    tools: ['Adobe Illustrator', 'Photoshop', 'InDesign']
  },
  {
    id: '2',
    title: 'Luxury Vehicle Wrap',
    category: 'Wrap Car Design',
    image: 'https://images.unsplash.com/photo-1683818051102-dd1199d163b9',
    description: 'Custom vehicle wrap design for luxury car brand showcase',
    client: 'AutoLux Motors',
    year: '2024',
    tools: ['Adobe Illustrator', '3D Mockup']
  },
  {
    id: '3',
    title: 'Corporate Website Redesign',
    category: 'Web Design',
    image: 'https://images.unsplash.com/photo-1619209629065-e9a2b225b24b',
    description: 'Modern, responsive website design for international consulting firm',
    client: 'Global Consulting Partners',
    year: '2023',
    tools: ['Figma', 'React', 'Tailwind CSS']
  },
  {
    id: '4',
    title: 'Office Wall Mural',
    category: 'Wall Wrap Design',
    image: 'https://images.unsplash.com/photo-1762146828422-50a8bd416d3c',
    description: 'Large-scale wall wrap design for modern corporate office space',
    client: 'Creative Hub Co.',
    year: '2024',
    tools: ['Adobe Illustrator', 'Large Format Print']
  },
  {
    id: '5',
    title: 'Brand Launch Campaign',
    category: 'Audio & Video',
    image: 'https://images.unsplash.com/photo-1519217651866-847339e674d4',
    description: 'Video production and audio design for brand launch campaign',
    client: 'Fashion Forward',
    year: '2023',
    tools: ['Premiere Pro', 'After Effects', 'Audition']
  },
  {
    id: '6',
    title: 'Annual Conference Design',
    category: 'Events',
    image: 'https://images.unsplash.com/photo-1736617004818-a01c44c494ee',
    description: 'Complete event design including stage design, signage, and promotional materials',
    client: 'Tech Summit 2024',
    year: '2024',
    tools: ['Adobe Suite', 'Stage Design', 'Print Production']
  },
  {
    id: '7',
    title: 'Product Packaging Series',
    category: 'Print Design',
    image: 'https://images.unsplash.com/photo-1655988940601-7702d8685f95',
    description: 'Minimalist packaging design series for premium product line',
    client: 'Organic Essentials',
    year: '2024',
    tools: ['Adobe Illustrator', 'Photoshop', 'Mockup Design']
  },
  {
    id: '8',
    title: 'Creative Workspace Branding',
    category: 'Web Design',
    image: 'https://images.unsplash.com/photo-1693159682618-074078ed271e',
    description: 'Digital brand experience and web platform for coworking space',
    client: 'WorkHub Collective',
    year: '2023',
    tools: ['Figma', 'WordPress', 'CSS3']
  }
];

export const mockProducts = [
  {
    id: 'prod-1',
    name: 'Premium Cotton T-Shirt',
    category: 'T-Shirts',
    price: 29.99,
    image: 'https://images.unsplash.com/photo-1542621334-a254cf47733d',
    description: 'High-quality cotton t-shirt with modern fit',
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
    colors: ['Black', 'White', 'Gray'],
    inStock: true
  },
  {
    id: 'prod-2',
    name: 'Designer Hoodie',
    category: 'Hoodies',
    price: 59.99,
    image: 'https://images.unsplash.com/photo-1502810190503-8303352d0dd1',
    description: 'Premium quality hoodie with unique design',
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
    colors: ['Black', 'Navy', 'Charcoal'],
    inStock: true
  },
  {
    id: 'prod-3',
    name: 'Signature Cap',
    category: 'Accessories',
    price: 24.99,
    image: 'https://images.unsplash.com/photo-1619209629065-e9a2b225b24b',
    description: 'Embroidered signature cap with adjustable strap',
    sizes: ['One Size'],
    colors: ['Black', 'White'],
    inStock: true
  },
  {
    id: 'prod-4',
    name: 'Limited Edition Jacket',
    category: 'Outerwear',
    price: 89.99,
    image: 'https://images.unsplash.com/photo-1652805363265-b8fbf9bbdfac',
    description: 'Exclusive design jacket from limited collection',
    sizes: ['M', 'L', 'XL'],
    colors: ['Black'],
    inStock: true
  }
];

export const mockBlogPosts = [
  {
    id: 'blog-1',
    title: 'The Future of Brand Design in 2024',
    category: 'Design',
    author: 'Enrique González',
    date: '2024-01-15',
    image: 'https://images.unsplash.com/photo-1736617004818-a01c44c494ee',
    excerpt: 'Exploring emerging trends in brand identity and visual communication for the modern era.',
    content: 'Full article content here...',
    status: 'published'
  },
  {
    id: 'blog-2',
    title: 'Optimizing Web Performance for Creative Portfolios',
    category: 'Technology',
    author: 'Enrique González',
    date: '2024-01-10',
    image: 'https://images.unsplash.com/photo-1619209629065-e9a2b225b24b',
    excerpt: 'Best practices for building fast, beautiful portfolio websites that load quickly.',
    content: 'Full article content here...',
    status: 'published'
  },
  {
    id: 'blog-3',
    title: 'Finding Balance in Creative Work',
    category: 'Life',
    author: 'Guest Contributor',
    date: '2024-01-05',
    image: 'https://images.unsplash.com/photo-1655988940601-7702d8685f95',
    excerpt: 'Personal reflections on maintaining work-life balance as a creative professional.',
    content: 'Full article content here...',
    status: 'pending'
  }
];

export const mockTools = [
  {
    id: 'tool-1',
    name: 'DTF Calculator',
    description: 'Quick cost and production calculator for DTF printing.',
    icon: 'Calculator',
    url: 'https://monumental-blini-da4e43.netlify.app/',
    category: 'Production'
  }
];

export const mockServices = [
  {
    id: 'srv-1',
    title: 'Print Design',
    description: 'Complete print design solutions from business cards to large format materials',
    icon: 'Printer'
  },
  {
    id: 'srv-2',
    title: 'Wrap Car Design',
    description: 'Custom vehicle wrap designs that make your brand mobile',
    icon: 'Car'
  },
  {
    id: 'srv-3',
    title: 'Wall Wrap Design',
    description: 'Transform spaces with stunning large-scale wall graphics',
    icon: 'Wallpaper'
  },
  {
    id: 'srv-4',
    title: 'Web Design',
    description: 'Modern, responsive websites built with latest technologies',
    icon: 'Globe'
  },
  {
    id: 'srv-5',
    title: 'Audio & Video',
    description: 'Professional audio and video production for your brand',
    icon: 'Video'
  },
  {
    id: 'srv-6',
    title: 'Events',
    description: 'Complete event design and production services',
    icon: 'Calendar'
  },
  {
    id: 'srv-7',
    title: 'Corporate Consulting',
    description: 'Business administration consulting focused on production structure and operational efficiency',
    icon: 'Briefcase'
  }
];

export const mockUser = {
  id: 'user-1',
  name: 'Enrique González',
  email: 'enrigo@ealagon.com',
  role: 'admin',
  isAuthenticated: false
};